<template>
  <v-container fluid>
    <v-card :loading="loading">
      <v-toolbar
        dark
        color="green"
        class="mt-3"
      >
        <v-toolbar-title>Wysyłanie wiadomości do: {{ FACILITY.name }}</v-toolbar-title>

      </v-toolbar>
      <FacilityEditSendMail
        v-on:FacilitySendEmail:sended="successMessage('Wiadomość wysłana poprawnie')"
        :facility="FACILITY"
      />
    </v-card>
    <Snackbar ref="snackbar" />
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";

import Snackbar from "./../../../shared/Snackbar.vue";
import FacilityEditSendMail from "./../FacilityEditSendMail.vue";

export default {
  name: "WindowSendEmail",
  components: {
    FacilityEditSendMail,
    Snackbar,
  },
  data: () => ({
    loading: false,
  }),
  computed: {
    ...mapGetters(["FACILITY"]),
  },
  methods: {
    successMessage(message) {
      this.$refs.snackbar.success(message);
    },
  },
  mounted() {
    this.loading = true;
    this.$store
      .dispatch("GET_FACILITY_BY_ID", { id: this.$route.params.id })
      .then(() => {
        this.loading = false;
      })
      .catch((error) => {
        this.loading = false;
        console.log(error);
      });
  },
};
</script>


<style>
</style>